import * as React from 'react'

import * as styles from './cardArea.module.css'

interface IProps {
  children?: React.ReactNode
  className?: string
}

const CardArea: React.SFC<IProps> = ({ children, className = '' }) => (
  <li className={`${styles.root} ${className}`}>{children}</li>
)

export default CardArea
